module.exports = __webpack_public_path__ + "img/adminServiceInfo3_back.6fd55c05.png";